export default {
  title: 'Termos de Serviço',
  lastUpdated: 'Última atualização: 27 de novembro de 2025',
  section1: {
    title: '1. Aceitação dos Termos',
    content1: 'Bem-vindo ao UmiGo. Ao acessar ou usar nosso aplicativo móvel, site ou quaisquer serviços relacionados (coletivamente, os "Serviços"), você concorda em estar vinculado a estes Termos de Serviço ("Termos"). Se você não concordar com estes Termos, não use nossos Serviços.',
    content2: 'Estes Termos constituem um acordo legalmente vinculativo entre você e o UmiGo ("nós" ou "nosso"). Reservamo-nos o direito de modificar estes Termos a qualquer momento, e seu uso continuado dos Serviços constitui aceitação de quaisquer alterações.'
  },
  section2: {
    title: '2. Elegibilidade',
    intro: 'Você deve ter pelo menos 13 anos (ou 16 em certas jurisdições) para usar o UmiGo. Ao usar nossos Serviços, você declara e garante que:',
    items: [
      'Você atende ao requisito de idade mínima',
      'Você tem capacidade legal para aceitar estes Termos',
      'Você cumprirá todas as leis e regulamentos aplicáveis',
      'Você não foi previamente banido de usar nossos Serviços',
      'Todas as informações que você fornece são precisas e verdadeiras'
    ]
  },
  section3: {
    title: '3. Registro de Conta e Segurança',
    intro: 'Para acessar certos recursos, você deve criar uma conta. Você concorda em:',
    items: [
      'Fornecer informações precisas, atuais e completas durante o registro',
      'Manter e atualizar prontamente as informações da sua conta',
      'Manter sua senha segura e confidencial',
      'Notificar-nos imediatamente de qualquer acesso não autorizado ou violação de segurança',
      'Aceitar responsabilidade por todas as atividades sob sua conta',
      'Não compartilhar sua conta com outros ou criar várias contas'
    ],
    note: 'Reservamo-nos o direito de suspender ou encerrar contas que violem estes Termos ou se envolvam em atividades suspeitas.'
  },
  section4: {
    title: '4. Conduta do Usuário e Atividades Proibidas',
    intro: 'Você concorda em não se envolver em nenhuma das seguintes atividades proibidas:',
    items: [
      'Assediar, ameaçar, intimidar ou intimidar outros usuários',
      'Publicar ou compartilhar conteúdo ilegal, prejudicial, ofensivo ou inadequado',
      'Personificar qualquer pessoa ou entidade ou deturpar sua afiliação',
      'Compartilhar conteúdo sexualmente explícito envolvendo menores',
      'Promover violência, terrorismo ou discurso de ódio',
      'Enviar spam, phishing ou se envolver em atividades fraudulentas',
      'Violar direitos de propriedade intelectual de outros',
      'Tentar hackear, interromper ou comprometer nossos Serviços',
      'Usar sistemas automatizados (bots) sem autorização',
      'Coletar informações de usuários sem consentimento',
      'Vender ou transferir sua conta',
      'Envolver-se em atividades comerciais sem nossa permissão'
    ]
  },
  section5: {
    title: '5. Conteúdo e Propriedade Intelectual',
    sub1: {
      title: '5.1 Seu Conteúdo',
      content: 'Você mantém a propriedade do conteúdo que cria e compartilha no UmiGo ("Conteúdo do Usuário"). Ao publicar Conteúdo do Usuário, você nos concede uma licença mundial, não exclusiva, livre de royalties e transferível para usar, reproduzir, distribuir, modificar, adaptar, exibir publicamente e executar publicamente seu Conteúdo do Usuário em conexão com a operação e fornecimento dos Serviços.'
    },
    sub2: {
      title: '5.2 Nosso Conteúdo',
      content: 'Todo o conteúdo, recursos e funcionalidade dos Serviços, incluindo, mas não se limitando a texto, gráficos, logotipos, ícones, imagens, clipes de áudio, clipes de vídeo e software, são de propriedade do UmiGo ou de nossos licenciadores e são protegidos por direitos autorais, marcas registradas e outras leis de propriedade intelectual.'
    },
    sub3: {
      title: '5.3 Moderação de Conteúdo',
      content: 'Reservamo-nos o direito de revisar, monitorar e remover Conteúdo do Usuário que viole estes Termos ou seja objetável, mas não somos obrigados a fazê-lo. Podemos usar sistemas automatizados e moderadores humanos para fazer cumprir nossas políticas de conteúdo.'
    }
  },
  section6: {
    title: '6. Itens Virtuais e Compras',
    intro: 'O UmiGo pode oferecer itens virtuais, presentes ou recursos premium para compra ("Itens Virtuais"). Você reconhece que:',
    items: [
      'Os Itens Virtuais não têm valor no mundo real e não podem ser trocados por dinheiro',
      'Todas as compras são finais e não reembolsáveis, exceto conforme exigido por lei',
      'Podemos modificar, suspender ou descontinuar Itens Virtuais a qualquer momento',
      'Os Itens Virtuais são perdidos se sua conta for encerrada',
      'Você é responsável por todas as cobranças incorridas sob sua conta',
      'Os preços estão sujeitos a alterações sem aviso prévio'
    ]
  },
  section7: {
    title: '7. Privacidade e Proteção de Dados',
    content: 'Sua privacidade é importante para nós. Nossa Política de Privacidade explica como coletamos, usamos e protegemos suas informações pessoais. Ao usar nossos Serviços, você consente com nossas práticas de dados conforme descrito na Política de Privacidade. Por favor, revise-a cuidadosamente.'
  },
  section8: {
    title: '8. Comunicações e Notificações',
    intro: 'Ao criar uma conta, você consente em receber comunicações de nós, incluindo:',
    items: [
      'Anúncios e atualizações relacionados ao serviço',
      'Alertas de segurança e notificações de conta',
      'Comunicações de marketing (das quais você pode optar por não participar)',
      'Respostas de suporte ao cliente'
    ],
    note: 'Você pode gerenciar suas preferências de comunicação nas configurações da sua conta.'
  },
  section9: {
    title: '9. Serviços e Links de Terceiros',
    content: 'Nossos Serviços podem conter links para sites, aplicativos ou serviços de terceiros. Não somos responsáveis pelo conteúdo, práticas de privacidade ou termos de serviço de terceiros. Suas interações com terceiros são exclusivamente entre você e eles.'
  },
  section10: {
    title: '10. Isenções de Responsabilidade e Limitações de Responsabilidade',
    sub1: {
      title: '10.1 Disponibilidade do Serviço',
      content: 'Os Serviços são fornecidos "como estão" e "conforme disponíveis" sem garantias de qualquer tipo. Não garantimos que os Serviços sejam ininterruptos, seguros ou livres de erros. Podemos modificar, suspender ou descontinuar qualquer parte dos Serviços a qualquer momento sem aviso prévio.'
    },
    sub2: {
      title: '10.2 Limitação de Responsabilidade',
      intro: 'Na máxima extensão permitida por lei, o UmiGo e suas afiliadas, diretores, funcionários e agentes não serão responsáveis por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos, incluindo, mas não se limitando a:',
      items: [
        'Perda de lucros, dados ou boa vontade',
        'Interrupção do serviço ou falha do sistema',
        'Custo de serviços substitutos',
        'Quaisquer danos decorrentes do seu uso ou incapacidade de usar os Serviços'
      ],
      note: 'Nossa responsabilidade total não excederá o valor que você nos pagou nos doze meses anteriores à reclamação, ou $100, o que for maior.'
    }
  },
  section11: {
    title: '11. Indenização',
    intro: 'Você concorda em indenizar, defender e isentar o UmiGo e suas afiliadas de quaisquer reivindicações, danos, perdas, responsabilidades e despesas (incluindo honorários advocatícios) decorrentes de:',
    items: [
      'Seu uso dos Serviços',
      'Sua violação destes Termos',
      'Sua violação de quaisquer direitos de outra parte',
      'Seu Conteúdo de Usuário'
    ]
  },
  section12: {
    title: '12. Encerramento',
    intro: 'Podemos suspender ou encerrar sua conta e acesso aos Serviços a qualquer momento, com ou sem aviso prévio, por qualquer motivo, incluindo se:',
    items: [
      'Você violar estes Termos',
      'Sua conta estiver inativa por um período prolongado',
      'Formos obrigados a fazê-lo por lei',
      'Decidirmos descontinuar os Serviços'
    ],
    note: 'Você pode excluir sua conta a qualquer momento através das configurações do aplicativo. Após o encerramento, seu direito de usar os Serviços cessará imediatamente, e podemos excluir seus dados de acordo com nossa Política de Privacidade.'
  },
  section13: {
    title: '13. Resolução de Disputas e Arbitragem',
    sub1: {
      title: '13.1 Resolução Informal',
      content: 'Se você tiver uma disputa conosco, entre em contato conosco primeiro em support@umigo.cc para tentar resolvê-la informalmente.'
    },
    sub2: {
      title: '13.2 Arbitragem Vinculativa',
      content: 'Se não pudermos resolver a disputa informalmente, qualquer disputa decorrente destes Termos ou dos Serviços será resolvida por meio de arbitragem vinculativa, exceto onde proibido por lei. Você concorda em renunciar ao seu direito a um julgamento por júri ou a participar de uma ação coletiva.'
    },
    sub3: {
      title: '13.3 Exceções',
      content: 'Qualquer uma das partes pode buscar medidas cautelares no tribunal por violação de propriedade intelectual ou acesso não autorizado aos Serviços.'
    }
  },
  section14: {
    title: '14. Lei Aplicável e Jurisdição',
    content: 'Estes Termos serão regidos e interpretados de acordo com as leis do México, sem considerar suas disposições sobre conflitos de leis. Qualquer ação ou processo legal será movido exclusivamente nos tribunais localizados na Cidade do México, México.'
  },
  section15: {
    title: '15. Alterações aos Termos',
    content: 'Reservamo-nos o direito de modificar estes Termos a qualquer momento. Notificaremos você sobre alterações materiais publicando os Termos atualizados em nosso site ou aplicativo e atualizando a data de "Última atualização". Seu uso continuado dos Serviços após as alterações entrarem em vigor constitui aceitação dos Termos modificados.'
  },
  section16: {
    title: '16. Diversos',
    sub1: {
      title: '16.1 Acordo Completo',
      content: 'Estes Termos, juntamente com nossa Política de Privacidade, constituem o acordo completo entre você e o UmiGo em relação aos Serviços.'
    },
    sub2: {
      title: '16.2 Divisibilidade',
      content: 'Se qualquer disposição destes Termos for considerada inválida ou inexequível, as disposições restantes permanecerão em pleno vigor e efeito.'
    },
    sub3: {
      title: '16.3 Renúncia',
      content: 'Nossa falha em fazer cumprir qualquer direito ou disposição destes Termos não constituirá uma renúncia a tal direito ou disposição.'
    },
    sub4: {
      title: '16.4 Cessão',
      content: 'Você não pode ceder ou transferir estes Termos sem nosso consentimento prévio por escrito. Podemos ceder estes Termos sem restrição.'
    }
  },
  section17: {
    title: '17. Informações de Contato',
    intro: 'Se você tiver alguma dúvida sobre estes Termos, entre em contato conosco:',
    email: '<strong>E-mail:</strong> support@umigo.cc',
    phone: '<strong>Telefone:</strong> WA: +52 8 132724843',
    address: '<strong>Endereço:</strong> Av. Paseo de la Reforma 222, Ciudad de México, CDMX 06600, México'
  },
  community: {
    title: 'Diretrizes da Comunidade',
    intro: 'Além destes Termos, todos os usuários devem seguir nossas Diretrizes da Comunidade:',
    items: [
      '<strong>Seja Respeitoso:</strong> Trate os outros com gentileza e respeito',
      '<strong>Fique Seguro:</strong> Proteja suas informações pessoais e relate comportamentos suspeitos',
      '<strong>Seja Autêntico:</strong> Use sua identidade real e não se passe por outros',
      '<strong>Mantenha a Legalidade:</strong> Não se envolva em atividades ilegais ou as promova',
      '<strong>Respeite a Privacidade:</strong> Não compartilhe informações privadas de outros sem consentimento',
      '<strong>Relate Problemas:</strong> Ajude-nos a manter uma comunidade segura relatando violações'
    ]
  }
};
